import ChartCard from "@/components/charts/ChartCard";

/** Horizontal bar list — readable on mobile and with long category names. */
export default function BarListChart({ title, subtitle, data = [], color = "#0D9488", testid, hideZero = false, className }) {
  const rows = hideZero ? data.filter((d) => d.count > 0) : data;
  const max = Math.max(1, ...rows.map((d) => d.count));
  const empty = rows.every((d) => !d.count);
  return (
    <ChartCard title={title} subtitle={subtitle} testid={testid} className={className} empty={empty ? "No data for this period" : null}>
      <div className="space-y-2.5">
        {rows.map((d) => (
          <div key={d.name} className="grid grid-cols-[minmax(0,9rem)_1fr_2.5rem] items-center gap-3 text-sm" data-testid={`${testid}-row-${d.name}`}>
            <span className="truncate text-slate-600" title={d.name}>{d.name}</span>
            <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden">
              <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${(d.count / max) * 100}%`, background: color }} />
            </div>
            <span className="text-right font-semibold text-slate-800">{d.count}</span>
          </div>
        ))}
      </div>
    </ChartCard>
  );
}
